import * as yup from 'yup';
import type { IValidationField } from '../types';
import { PRODUCT_CUSTOM_PAYMENT_CODE, PRODUCT_MAX_PAYMENT_DUE_DATE } from 'appConstants';
import { t } from 'i18next';
import { displayDate } from 'utils';

export default function paymentDueDate({ label = '' }: IValidationField) {
  return yup
    .string()
    .label(label)
    .default('')
    .when('paymentTermsCode', {
      is: (val: string) => val === PRODUCT_CUSTOM_PAYMENT_CODE,
      then: (schema) =>
        schema
          .required()
          .isValidDate(
            t('errors.isValidDate', {
              label: label,
            }),
          )
          .isFutureDate(
            t('errors.isFutureDate', {
              label: label,
            }),
          )
          .maxDate(
            t('errors.maxDate', {
              label: label,
              maxDate: displayDate(PRODUCT_MAX_PAYMENT_DUE_DATE),
            }),
            PRODUCT_MAX_PAYMENT_DUE_DATE,
          ),

      otherwise: (schema) => schema,
    });
}
